import React from 'react';
import { TranslationKey } from './../../../../types/translation/TranslationKey';
import { ProductMasterData } from '../../../../types/product_master_data/productMasterData';
import { t } from '../../../../types/translation/Translator';
import { BaseFilter } from '../common/BaseFilter';
import { ReorderRuleProduct } from '../../../../ui/pages/Common/ReorderRules/ReorderRuleScreen';
import { FilterProps } from '../common/filter.util';
import { itemsContainText } from '../../../../util/string.util';

export class ReorderRuleProductFilter extends BaseFilter<ReorderRuleProduct> {
  productMasterData: Map<string, ProductMasterData>;
  constructor(productMasterData: Map<string, ProductMasterData>) {
    super();
    this.productMasterData = productMasterData;
  }
  toLabel(): string {
    return t(TranslationKey.reorderRuleForProduct).singular.label;
  }

  toCount(): number {
    return 0;
  }

  toIcon(): JSX.Element {
    return <></>;
  }

  toDropdownContent(): JSX.Element {
    return <></>;
  }

  toInnerContent(): string | JSX.Element {
    return <></>;
  }

  search(item: ReorderRuleProduct, query: string) {
    const pmd = this.productMasterData.get(item.productMasterDataId);
    if (!pmd) return false;

    return itemsContainText(query, [pmd.productName, pmd.productNumber]);
  }

  filteredItems(items: ReorderRuleProduct[], query: string, filterProps: FilterProps): ReorderRuleProduct[] {
    return items.filter(item => {
      return [this.search(item, query)].every(value => value === null || value);
    });
  }
}
